import { useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import ContactSupport from "../../components/HelpCentre/ContactSupport";

/**
 * The Help Centre's frame: one scroll area holding the current page and,
 * sticky at its foot, the contact card. Only the page swaps as the reader
 * moves around, so the scroll area and a contact draft survive it.
 */
function HelpCentreLayout() {
	const scrollArea = useRef<HTMLDivElement>(null);
	const { pathname } = useLocation();
	const navigationType = useNavigationType();

	// A new page starts at the top; Back and Forward leave the scroll alone.
	// Keyed on the path only, so typing a search (?q=) doesn't scroll. A layout
	// effect, so it runs before the pages' passive effects: FaqList's scroll to
	// an opened question comes after this, not before.
	useLayoutEffect(() => {
		if (navigationType !== "POP") scrollArea.current?.scrollTo({ top: 0 });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	return (
		<div ref={scrollArea} className="help-centre">
			<div className="help-centre__page">
				<Outlet />
			</div>
			<ContactSupport />
		</div>
	);
}

export default HelpCentreLayout;
